import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import { Grid, Typography } from "@mui/material";
import companyLogo from "../assets/images/Logo/logo.png";
import "../assets/css/login.css";

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  const { dispatch } = useAuthContext();

  const handleLogout = () => {
    localStorage.removeItem("user");
    dispatch({ type: "LOGOUT" });
    navigate("/");
  };

  return (
    <Grid container className="full-height">
      <div className="blueprint-bg" />

      {/* ═══════════════════════════════════════
          LEFT PANE — Branding + Hub (matching Login)
          ═══════════════════════════════════════ */}
      <Grid item xs={12} lg={7.5} md={7.5} sm={7.5} className="left-branding-pane">
        {/* Logo */}
        <div className="logo-container-new">
          <img src={companyLogo} alt="KG Build Tech" className="logo-image-new" />
        </div>

        {/* Main content row */}
        <div className="left-pane-layout">
          {/* Branding text */}
          <div className="branding-text-column">
            <Typography variant="h1" className="main-title-new">
              <span className="navy">Build More.</span>
              <span className="blue">Manage Everything.</span>
            </Typography>
            <Typography className="main-desc-new">
              KG Build Tech's complete construction operations platform — projects, labour, procurement, payroll and approvals, all in one place.
            </Typography>
          </div>

          {/* Operations Hub — circular nodes on orbit ring */}
          <div className="hub-column">
            <div className="hub-visual-container">
              <svg className="hub-svg-overlay" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
                <circle cx="200" cy="200" r="157" className="hub-orbit-ring" />
                <circle cx="200" cy="200" r="100" className="hub-orbit-ring-inner" />
                <path id="orbit-travel" d="M200,43 A157,157 0 1,1 199.9,43 Z" fill="none" />
                <circle className="pulse-dot" r="5">
                  <animateMotion dur="12s" repeatCount="indefinite">
                    <mpath href="#orbit-travel" />
                  </animateMotion>
                </circle>
                <circle className="pulse-dot" r="4" opacity="0.5">
                  <animateMotion dur="12s" begin="6s" repeatCount="indefinite">
                    <mpath href="#orbit-travel" />
                  </animateMotion>
                </circle>
              </svg>

              {/* Center KG logo */}
              <div className="hub-center-symbol">
                <img src={companyLogo} alt="KG Build Tech" />
              </div>

              {/* PROJECTS — top */}
              <div className="hub-node node-projects">
                <div className="hub-node-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M3 21h18M3 7v14M21 7v14M12 3L3 7h18l-9-4zM10 12h4v4h-4v-4z" />
                  </svg>
                </div>
                <span className="hub-node-label">Projects</span>
              </div>

              {/* LABOUR — left */}
              <div className="hub-node node-people">
                <div className="hub-node-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M2 20h20M12 2a7 7 0 017 7H5a7 7 0 017-7z" />
                    <path d="M5 9v3a7 7 0 0014 0V9" />
                    <path d="M12 2v3M4 9h16" />
                  </svg>
                </div>
                <span className="hub-node-label">Labour</span>
              </div>

              {/* PROCUREMENT — right */}
              <div className="hub-node node-procurement">
                <div className="hub-node-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4H6zM3 6h18M16 10a4 4 0 01-8 0" />
                  </svg>
                </div>
                <span className="hub-node-label">Procurement</span>
              </div>

              {/* PAYROLL — bottom */}
              <div className="hub-node node-finance">
                <div className="hub-node-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <rect x="2" y="5" width="20" height="14" rx="2" />
                    <path d="M2 10h20M6 15h4M14 15h4" />
                  </svg>
                </div>
                <span className="hub-node-label">Payroll</span>
              </div>

            </div>
          </div>
        </div>
      </Grid>

      {/* ═══════════════════════════════════════
          RIGHT PANE — Unauthorized Card
          ═══════════════════════════════════════ */}
      <Grid item xs={12} lg={4.5} md={4.5} sm={4.5} className="right-login-pane">
        <div className="login-card-container">
          <div className="login-card-new" style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
            
            {/* Red Security Shield / Alert Icon */}
            <div className="security-icon-container" style={{ background: "rgba(220, 38, 38, 0.08)", color: "#dc2626" }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 8v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="12" cy="16" r="1" fill="currentColor" />
              </svg>
            </div>

            <Typography variant="h5" className="login-welcome-title" style={{ marginTop: "8px", marginBottom: "4px" }}>
              Access Restricted
            </Typography>

            <div style={styles.badge}>403</div>

            <div style={{ height: "24px" }} />

            <Typography
              variant="h6"
              fontWeight="700"
              sx={{ color: "#1a1a2e", mb: 1 }}
            >
              You are not authorized to view this page
            </Typography>

            <Typography
              variant="body2"
              sx={{ color: "#6b7280", lineHeight: 1.8, mb: 3, px: 1 }}
            >
              This portal is restricted to authorized management personnel only.
              <br />
              Please contact your system administrator if you believe this is a mistake.
            </Typography>

            {/* Animated bouncing dots */}
            <div style={styles.dotsRow}>
              <span style={styles.dot} />
              <span style={{ ...styles.dot, animationDelay: "0.18s" }} />
              <span style={{ ...styles.dot, animationDelay: "0.36s" }} />
            </div>

            <div style={{ height: "20px" }} />

            {/* Back to Login button */}
            <button 
              className="btn-primary-new" 
              onClick={handleLogout} 
              style={{ border: "none", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ marginRight: 8 }}>
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
                  stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Back to Login
            </button>
          </div>
        </div>
      </Grid>

      <style>{`
        @keyframes dotBounce {
          0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
          40% { transform: translateY(-8px); opacity: 1; }
        }
      `}</style>
    </Grid>
  );
}

const styles = {
  badge: {
    display: "inline-block",
    background: "linear-gradient(135deg, #0d52a2, #035aa7)",
    color: "#fff",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 1.5,
    padding: "4px 14px",
    borderRadius: 20,
    marginTop: 4,
  },
  dotsRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    marginBottom: 4,
  },
  dot: {
    display: "inline-block",
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "#0d52a2",
    animation: "dotBounce 1.3s ease-in-out infinite",
    opacity: 0.5,
  },
};
